import {
  AttachmentCategoryEnum,
  type MbcBriefAssetFile,
  ModelsEnum,
} from "@nlc/shared-types";

import type { PresignedUrlResponse } from "@/components/file-uploader/types";

import apiClient from "@/lib/api/client";

/**
 * Upload an MBC file through the classic backend presign: 1) presign
 * (`isMbc=true`, so the row is created owned by the caller and never reaped),
 * 2) upload to S3. No AI-service registration — the attachments row already
 * carries the durable url, so the brief stores the presign response directly.
 */
export async function uploadAsset(
  file: File,
  requestId: number,
): Promise<MbcBriefAssetFile> {
  const { attachmentId, fields, presignedUrl, url } = await apiClient
    .query({
      fileName: file.name,
      isMbc: true,
      parentId: requestId,
      parentType: ModelsEnum.REQUEST,
      size: file.size.toString(),
      type: AttachmentCategoryEnum.ASSET,
    })
    .get("/attachments/upload-url")
    .json<PresignedUrlResponse>();

  const form = new FormData();

  for (const [key, value] of Object.entries(fields)) {
    form.append(key, value);
  }
  form.append("file", file);

  const uploadResponse = await fetch(presignedUrl, {
    body: form,
    method: "POST",
  });

  if (!uploadResponse.ok) {
    throw new Error("S3 upload failed");
  }

  return {
    attachmentId,
    mime: file.type || "application/octet-stream",
    name: file.name,
    size: file.size,
    url,
  };
}
